import { defineComponent, h } from 'vue';
import { QInput, QIcon, QTooltip } from 'quasar';
import utils from '../../../../Shared/utils.jsx';
import methods from '../../../../Shared/methods';

export default defineComponent({
    name: 'form-input-dsgn',
    components: {
        QInput,
        QIcon,
        QTooltip,
    },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedNode == this;
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
    },
    props: {
        name: '',
        type: null,
        schemakey: '',
        root: null,
        designmodel: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
    },
    render() {
        const placeholder = this.schema.placeholder || '';
        const description = this.schema.description;
        const value = this.cmodel?.[this.schemakey] ?? '';

        return (
            <div
                class={{ 'designer-form': true }}
                style={{ xmarginLeft: (this.child * 15) + 'px', position: 'relative' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                <QInput
                    type={this.type == 'password' ? 'password' : "text"}
                    outlined
                    dense
                    label={this.name}
                    hint={description ?? ''}
                    disable={this.readonly}
                    modelValue={value}
                    placeholder={placeholder}
                    style={{ width: '100%' }}
                >
                </QInput>
            </div>
        );
    }
});